jQuery(document).ready(function ($) {
    let running = false;

    $.fn.toggleNavMenu = function () {
        if (running) {
            return this;
        }

        running = true;

        let item = this.attr('data-nav-item-name');
        this.toggleClass('active');
        $(`.site-header__submenu[data-nav-item-name="${item}"]`).stop(true, true).fadeToggle(500);

        running = false;

        return this;
    }

    $.fn.openNavMenu = function () {
        if (running) {
            return this;
        }

        if (this.hasClass('active')) {
            return this;
        }

        running = true;

        let item = this.attr('data-nav-item-name');
        this.addClass('active');
        $(`.site-header__submenu[data-nav-item-name="${item}"]`).stop(true, true).fadeIn(500);

        running = false;

        return this;
    }

    $.fn.keepNavMenuOpen = function () {
        let item = this.attr('data-nav-item-name');
        this.addClass('active');
        $(`.site-header__submenu[data-nav-item-name="${item}"]`).stop(true, true).show();
        return this;
    }

    $.fn.closeNavMenu = function () {
        if (running) {
            return this;
        }

        running = true;

        this.each(function () {
            let item = $(this).attr('data-nav-item-name');

            $(this).removeClass('active');
            $(`.site-header__submenu[data-nav-item-name="${item}"]`).stop(true, true).fadeOut(500);
        })

        running = false;

        return this;
    }

    $('.site-header').on('mouseleave', function (event) {
        $('.site-header__item').closeNavMenu();
    });

    $('.site-header__item').on('mouseenter', function (event) {
        event.preventDefault();

        $('.site-header__item').not(this).closeNavMenu();

        $(this).openNavMenu();
    });

    $('.site-header__item:not([data-nav-item-name])').on('touchstart', function (event) {
        $('.site-header__item').closeNavMenu();
    });

    $('.site-header__item[data-nav-item-name]').on('touchstart', function (event) {
        event.preventDefault();

        $('.site-header__item').not(this).closeNavMenu();

        $(this).toggleNavMenu();
    });

    $('.site-header__submenu').on('mouseover mouseenter', function (event) {
        event.preventDefault();

        $(this).keepNavMenuOpen();
    });

    $('.site-header__logo').on('mouseenter touchstart', function (event) {
        $('.site-header__item').closeNavMenu();
    });

    $('.site-header__right').on('mouseenter touchstart', function (event) {
        $('.site-header__item').closeNavMenu();
    });

    $('.site-header__search').on('click', function (event) {
        event.stopPropagation();

        $('.site-header__item').closeNavMenu();
        $('.site-header__mobile').closeNavMenu();

        $(this).toggleClass('active');
        $(`.site-header__submenu[data-nav-item-name="search"]`).stop(true, true).fadeToggle(500);
    });

    $('.site-header__mobile').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        $('.site-header__search').closeNavMenu();

        $(this).toggleNavMenu();
    });

    $.fn.toggleHeaderScroll = function () {
        if (this.scrollTop() > 120) {
            $('.site-header').addClass('scroll');
        } else {
            $('.site-header').removeClass('scroll');
        }

        return this;
    }

    $(document).toggleHeaderScroll().on('scroll', function (event) {
        $(this).toggleHeaderScroll();
    });

    $.fn.openCollapse = function () {
        if (running) {
            return this;
        }

        running = true;

        this.addClass('active');
        this.next().slideUp(500);

        running = false;

        return this;
    }

    $.fn.closeCollapse = function () {
        if (running) {
            return this;
        }

        running = true;

        this.each(function () {
            $(this).removeClass('active');
            $(this).next().slideUp(500);
        });

        running = false;

        return this;
    }

    $.fn.toggleCollapse = function () {
        if (running) return this;
        running = true;

        this.toggleClass('active');
        this.next().slideToggle(500);

        running = false;

        return this;
    }

    $('.site-header__collapse--label').on('click', function (event) {
        event.stopPropagation();

        $('.site-header__collapse--label').not(this).closeCollapse();
        $(this).toggleCollapse();
    });
});